import { envConfig } from './envConfig'
import EnvConfigContext from './EnvConfigContext'

interface EnvConfigProviderProps {
  children: React.ReactNode
}

const EnvConfigProvider = ({ children }: EnvConfigProviderProps) => (
  <EnvConfigContext.Provider value={{ envConfig }}>{children}</EnvConfigContext.Provider>
)

export default EnvConfigProvider
